
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import HinaRadioGroup from "@/views/ai-builder-component/baseComponent/hina-radio-group.vue";
import HinaUpload from "../baseComponent/hina-upload.vue";
import Pop from "../components/blue-pop.vue";
import { ElForm } from "element-ui/types/form";

@Component({
  components: {
    HinaRadioGroup,
    IntroduceCard,
    HinaUpload,
    Pop
  }
})
export default class ParamsCom extends Vue {
  @Prop() formItemData!: ExamVersionInfo;

  defaultCoverUrl =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";

  loginTypeOptions = [
    { name: "手机号验证码 + 姓名", value: 1 },
    { name: "手机号验证码", value: 0 },
    { name: "微信授权手机号 + 姓名", value: 2 }
  ];
  skipTypeOptions = [
    { name: "信息不全不跳过", value: 0 },
    { name: "首次或信息不全不跳过", value: 1 },
    { name: "不跳过", value: 2 }
  ];
  // 背景
  publicityPageCoverTypeOptions = [
    { name: "公司默认背景", value: 1 },
    { name: "自定义背景", value: 2 }
  ];

  //后端缺少背景图片类型字段  前端自己组下  1默认背景  2自定义背景
  useDefaultCover = 1;

  @Watch("formItemData.loginConfig.loginBgUrl", {
    immediate: true
  })
  changeRadio() {
    this.useDefaultCover =
      this.formItemData.loginConfig.loginBgUrl === "" ? 1 : 2;
  }
  handleChangePublicityPageCoverType(v: number) {
    if (v === 1) {
      this.formItemData.loginConfig.loginBgUrl = "";
    }
    this.handleChange();
  }
  handleChange(field?: string) {
    if (field) {
      (this.$refs.formRef as any).validateField(field);
    }
    this.$emit("setBar", false);
  }
  get rules() {
    return {
      "loginConfig.loginBgUrl": [
        {
          required: this.useDefaultCover === 2,
          message: "请上传自定义背景",
          trigger: ["blur", "change"]
        }
      ]
    };
  }

  // 校验数据
  async formItemCheck() {
    try {
      await (this.$refs.formRef as ElForm).validate();
      return "";
    } catch (error) {
      return "loginPage";
    }
  }
}
